import { IStoreProps } from '../../index';
import React, { useEffect, useRef } from 'react';
import { INotification } from '../../notifications-interfaces';
import NonReadIndicator from './non-read-indicator';
import NotificationIcon from './notification-icon';
import NotificationText from './notification-text';
import DotsMenu from './dots-menu/dots-menu';

interface INotificationsListProps {
    storeProps: IStoreProps;
    notification: INotification;
}

const NotificationsItem = ({ storeProps, notification }: INotificationsListProps) => {

    const { useAppSelector } = storeProps;

    const itemRef = useRef<HTMLDivElement>(null);

    const selectedItemGuid = useAppSelector(store => store.root.selectedItemGuid);

    useEffect(() => {
        if(selectedItemGuid !== notification.userNTFGUID) return;

        setTimeout(() => {
            itemRef.current?.focus();
        }, 150);
    } ,[selectedItemGuid, notification.userNTFGUID]);

    return (
        <div
            ref={ itemRef }
            tabIndex={0}
            className={`grid top-notifications__grid items-center mb-4 ${ notification.isRead ? 'text-gray-400' : 'text-gray-900' }`}>

            <NonReadIndicator
                storeProps={ storeProps }
                notification={ notification }
            />

            <NotificationIcon
                storeProps={ storeProps }
                notification={ notification }
            />

            <NotificationText
                storeProps={ storeProps }
                notification={ notification }
            />

            <DotsMenu
                storeProps={ storeProps }
                notification={ notification }
            />

        </div>
    )
};

export default NotificationsItem;